async function getAnswer(questionId: string, jwt: string): Promise<any> {
  const endpoint = window.encodeURI(
    `/api/v1/polls/questions/${questionId}/answer`
  );
  const response = await fetch(endpoint, {
    headers: { Authorization: `Bearer ${jwt}` },
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error('unable to load poll answer');
  }
}

interface PostAnswerParams {
  questionId: string;
  jwt: string;
  choiceId?: string;
  tellUsMore?: string;
}

async function postAnswer({
  questionId,
  jwt,
  choiceId,
  tellUsMore,
}: PostAnswerParams): Promise<any> {
  const endpoint = window.encodeURI(
    `/api/v1/polls/questions/${questionId}/answer`
  );

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
    },
    body: JSON.stringify({
      choice_id: choiceId,
      tell_us_more: tellUsMore,
    }),
  });
  if (response.ok) {
    return response.json();
  } else {
    throw new Error('answer rejected');
  }
}

export { getAnswer, postAnswer };
